import React, { useEffect, useRef, useState } from 'react';
import { LinkIcon, CheckIcon } from 'lucide-react';
import { DS } from '../../ds';
import type { BlogArticle } from '../../../data/blogArticles';
interface ShareButtonsProps {
  article: BlogArticle;
}
const BLOG_BASE_URL = 'https://alinova.co/blog';
export const ShareButtons = ({
  article
}: ShareButtonsProps) => {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef<ReturnType<typeof setTimeout>>();
  const shareUrl = `${BLOG_BASE_URL}/${article.id}`;
  const title = article.title;
  useEffect(() => {
    return () => {
      if (resetTimer.current) clearTimeout(resetTimer.current);
    };
  }, []);
  const shareOnLinkedIn = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`, '_blank', 'noopener,noreferrer');
  };
  const shareOnWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(`${title} ${shareUrl}`)}`, '_blank', 'noopener,noreferrer');
  };
  const shareOnTwitter = () => {
    window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}`, '_blank', 'noopener,noreferrer');
  };
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      if (resetTimer.current) clearTimeout(resetTimer.current);
      resetTimer.current = setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };
  const buttonStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '7px',
    padding: '9px 16px',
    borderRadius: DS.radius.pill,
    border: `1.5px solid ${DS.color.border}`,
    background: '#fff',
    color: DS.color.ink,
    fontFamily: DS.font.body,
    fontSize: '13px',
    fontWeight: 700,
    cursor: 'pointer',
    transition: `border-color 0.2s ${DS.ease.smooth}, color 0.2s ${DS.ease.smooth}`
  };
  const onHover = (color: string) => (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.borderColor = color;
    e.currentTarget.style.color = color;
  };
  const onLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.borderColor = DS.color.border;
    e.currentTarget.style.color = DS.color.ink;
  };
  return <div style={{
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap'
  }} data-id="element-315" data-mp="2poknvd3b00hf">
      <button type="button" onClick={shareOnLinkedIn} style={buttonStyle} onMouseEnter={onHover('#0A66C2')} onMouseLeave={onLeave} data-id="element-316" data-mp="33g91jkt7ax0i">
        LinkedIn
      </button>
      <button type="button" onClick={shareOnWhatsApp} style={buttonStyle} onMouseEnter={onHover(DS.color.teal)} onMouseLeave={onLeave} data-id="element-317" data-mp="3df89t2a20qmz">
        WhatsApp
      </button>
      <button type="button" onClick={shareOnTwitter} style={buttonStyle} onMouseEnter={onHover(DS.color.ink)} onMouseLeave={onLeave} data-id="element-318" data-mp="1j3tkgmkygt7r">
        X (Twitter)
      </button>
      <button type="button" onClick={copyLink} style={copied ? {
      ...buttonStyle,
      borderColor: DS.color.aqua,
      color: DS.color.tealDeep,
      background: DS.color.mint
    } : buttonStyle} onMouseEnter={onHover(DS.color.aqua)} onMouseLeave={onLeave} data-id="element-319" data-mp="3up2h0gqetptw">
        {copied ? <CheckIcon size={14} aria-hidden="true" data-id="element-320" data-mp="3b2e6wwtzvabd" /> : <LinkIcon size={14} aria-hidden="true" data-id="element-321" data-mp="2x1toi1rzrgie" />}
        {copied ? 'Enlace copiado' : 'Copiar enlace'}
      </button>
      <span aria-live="polite" style={{
      position: 'absolute',
      left: '-9999px'
    }} data-id="element-322" data-mp="321pto4cfddzj">
        {copied ? 'Enlace copiado al portapapeles' : ''}
      </span>
    </div>;
};